import { render, staticRenderFns } from "./LanguageDelete.vue?vue&type=template&id=e204f750&scoped=true&"
import script from "./LanguageDelete.vue?vue&type=script&lang=js&"
export * from "./LanguageDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e204f750",
  null
  
)

export default component.exports